<template>
  <div>
    <!--    {{ item }}-->
    <div class="boxs">
      <div class="top">{{ item.title }}</div>
      <div class="content">
        <Row>
          <Col :span="24"><span class="title">发生区域:</span>{{ item.deptName }}</Col>
          <Col :span="24"><span class="title">发布时间:</span>{{ $moment(item.releaseTime).format('yyyy-MM-DD') }}</Col>
          <Col :span="24"><span class="title">内容:</span>
            <div v-html="item.content"></div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "RoadWindows",
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  mounted() {
  }
}
</script>

<style scoped lang="less">
.boxs {
  position: relative;
  height: 12rem;

  .top {
    color: #ffffff;
    height: 4vh;
    line-height: 4vh;
    padding-left: .5rem;
    font-size: .7rem;
  }

  .content {
    padding-left: .5rem;
    color: #ffffff;
    font-size: .7rem;
    overflow: auto;
    height: 70%;

    .title, .ivu-col {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 90%;
    }

    &::-webkit-scrollbar {
      display: none;
    }

    .ivu-col {
      line-height: 1.4rem;
    }

    .title {
      color: #72aefa;
    }
  }
}
</style>
